import { gridGutterWidth } from '../core/constants';
import { breakpoints } from '../core/constants';

export const SWIPER_CONFIG = {
    direction: 'horizontal',
    effect: 'slide',
    grabCursor: true,
    loop: true,
    spaceBetween: gridGutterWidth / 2,
    createElements: true,
    watchOverflow: true,
    wrapperClass: 'carousel__wrapper',
    navigation: {
        nextEl: '.carousel__button--next',
        prevEl: '.carousel__button--prev',
        disabledClass: '.carousel__button--disabled',
    },

    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
        loadPrevNext: false,
        checkInView: true,
        elementClass: 'carousel__lazy',
    },

    // Slides
    slideActiveClass: 'carousel__slide--is-active',
    slideClass: 'carousel__slide',
    slideDuplicateClass: 'carousel__slide--duplicate',
    slideNextClass: 'carousel__slide--next',
    slidePrevClass: 'carousel__slide--prev',
    slidesPerView: 1,
    centeredSlides: false,

    // Responsive
    breakpoints: {
        [breakpoints.lg]: {
            spaceBetween: gridGutterWidth,
        },
    },
};

export const SWIPER_SIZES = {
    'fourth': 4,
    'half': 2,
    'third': 3,
    'two-third': 3 / 2,
    'full': 1,
};
